<template>
    <div class="ai-response text--primary text-body-1">{{ text }}
        <span
            v-if="isTyping"
            class="cursor-wrapper"
        >
            <span class="cursor-label">
                <v-icon size="small" class="ai">
                    mdi-creation
                </v-icon>

                Claudia
            </span>

            <span class="cursor"></span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ArdiChunkWriting',

    props: {
        text: {
            type: String,
            required: true,
        },

        isTyping: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.ai-response {
    padding: 16px;
    border-radius: 12px;
    background: rgb(var(--v-theme-surface));
    line-height: 1.7;
    white-space: pre-wrap;
    min-height: 120px;
    border: 1px solid #E6E6E6;
    max-height: 300px;
    overflow-y: scroll;
}

.cursor-wrapper {
    position: relative;
    display: inline-flex;
    align-items: flex-end;
}

.cursor {
    width: 2px;
    height: 20px;
    background: #3490dc;
    animation: blink 1s infinite;
}

.cursor-label {
    position: absolute;
    top: -20px;
    left: -2px;
    background: #e9e9e9;
    color: #3490dc;
    font-size: 11px;
    padding: 1px 5px;
    border-radius: 4px;
    white-space: nowrap;
    font-weight: 600;
}

@keyframes blink {
    50% {
        opacity: 0;
    }
}
</style>